import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../../components/common/header/Header";
import Footer from "../../components/common/footer/Footer";
import { Error as ErrorIcon } from '@mui/icons-material';
import './PaymentResult.css';

function PaymentFailurePage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Clear any purchase data from localStorage
    localStorage.removeItem('currentPurchaseId');
    localStorage.removeItem('email');
  }, []);
  
  const handleTryAgain = () => {
    navigate('/checkout');
  };
  
  const handleGoToHome = () => {
    navigate('/home');
  };
  
  return (
    <>
      <Header />
      <div className="payment-result-container">
        <div className="payment-result-card failure">
          <div className="failure-icon">
            <ErrorIcon />
          </div>
          <h1>Payment Failed</h1>
          <p className="failure-message">
            We couldn't process your payment. Your card has not been charged.
          </p>
          
          <div className="payment-failure-reasons">
            <h3>This could be due to:</h3>
            <ul>
              <li>Insufficient funds in your account</li>
              <li>Incorrect card details</li>
              <li>Your bank declined the transaction</li>
              <li>Network or connection issues</li>
              <li>You cancelled the payment process</li>
            </ul>
          </div>
          
          <div className="payment-result-actions">
            <button 
              className="payment-result-button primary" 
              onClick={handleTryAgain}
            >
              Try Again
            </button>
            <button 
              className="payment-result-button secondary" 
              onClick={handleGoToHome}
            >
              Return to Home
            </button>
          </div>
          
          <div className="payment-support-info">
            <p>If you continue to experience issues, please contact our support team.</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PaymentFailurePage;
